// actions/connect/register.js

import { attachAuth } from '../../utils/authService';
import PubSub         from 'pubsub-js';

// --- ALL ---

export function connectRegisterHasErrored(bool) {
  return {
    type: 'CONNECT_REGISTER_HAS_ERRORED',
    hasErrored: bool
  };
}

export function connectRegisterIsLoading(bool) {
  return {
    type: 'CONNECT_REGISTER_IS_LOADING',
    isLoading: bool
  };
}

export function connectRegisterFetchDataSuccess(obj) {
  return {
    type: 'CONNECT_REGISTER_FETCH_DATA_SUCCESS',
    obj
  };
}

export function connectRegisterFetchData(host, msg) {
  return (dispatch) => {
    dispatch(connectRegisterIsLoading(true));
    dispatch(connectRegisterHasErrored(false));
    fetch(host + 'connect/register', {
      method: 'post',
      body: JSON.stringify(msg),
      headers: attachAuth()
    }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        }
        
        promise.json()
          .then(result => {
            dispatch(connectRegisterFetchDataSuccess(result));
            dispatch(connectRegisterHasErrored(false));
            dispatch(connectRegisterIsLoading(false));
            PubSub.publish('register.response', result);
          })
          .catch((ex) => {
            console.log(ex);
            dispatch(connectRegisterHasErrored(true));
            dispatch(connectRegisterIsLoading(false));
            PubSub.publish('register.response.error');
          });
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(connectRegisterHasErrored(true));
      dispatch(connectRegisterIsLoading(false));
      PubSub.publish('register.response.error');
    });
  };
}